import {
    INCO_TERMS_LIST,
    COUNTRY_LIST,
    UOM_TYPE_LIST,
    SALES_PERSON_LIST,
    DOCUMENT_TYPE_PURCHASE_LIST,
    DOCUMENT_TYPE_SALES_LIST,
    QUANTITY_TYPE_LIST,
    COMMODITYGROUP,
    CONTAINER_TYPE_LIST,
    OPERATOR_LIST,
    MOVE_TYPE,
    CURRENCY_LIST,
    CHARGE_BASIS_LIST,
    UOM_LIST,
    FILE_MANAGER_LIST,
    MASTER_COMPANY_DETAIL,
    STANDARD_TERMS_LIST,
    CHARGES_DESCRIPTION_LIST,
    ACCOUNT_ADDRESSBOOK_MODULE_LIST,
    ACCOUNT_ADDRESSBOOK_BASIS_LIST,
    CARRIER_LIST,
    OFFICE_TYPE,
    PROFIT_CENTER,
    PACKAGE_TYPE,
    MANUFACTURER_LIST,
    NOTES_TYPE,
    BL_TYPE_LIST,
    CLOADER_LIST
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const getIncoTermsList = () => {
    return dispatch => {
        const url = `v1/Common/GetIncoTerms`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: INCO_TERMS_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

export const getCountryList = () => {
    return dispatch => {
        const url = `v1/Common/GetCountry`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: COUNTRY_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

export const getUomTypeList = () => {
    return dispatch => {
        const url = `v1/Common/GetUomType`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: UOM_TYPE_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}

export const getSalesPersonList = () => {
    return dispatch => {
        const url = `v1/Common/GetSalesPerson`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: SALES_PERSON_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}

export const getDocumentTypePurchaseList = () => {
    return dispatch => {
        const url = `v1/Common/GetDocumentType?DocType=PO`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: DOCUMENT_TYPE_PURCHASE_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}

export const getDocumentTypeSalesList = () => {
    return dispatch => {
        const url = `v1/Common/GetDocumentType?DocType=SO`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: DOCUMENT_TYPE_SALES_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}


export const getQuantityTypeList = () => {
    return dispatch => {
        const url = `v1/Common/GetQuantityType`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: QUANTITY_TYPE_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}

export const getCommodityGroup = () => {
    return dispatch => {
        const url = `v1/Common/GetCommodityGroup`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: COMMODITYGROUP,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}

export const getContainerType = () => {
    return dispatch => {
        const url = `v1/Common/GetContainerType`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: CONTAINER_TYPE_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}

export const GetOperator = () => {
    return dispatch => {
        const url = `v1/Common/GetOperator`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: OPERATOR_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}


export const getMoveType = () => {
    return dispatch => {
        const url = `v1/Common/GetMoveType`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: MOVE_TYPE,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}



export const getClauselist = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        const url = `v1/Common/GetClauseList?${queryParams}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {

                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}


export const GetCurrencyList = () => {
    return dispatch => {
        const url = `v1/Common/GetCurrencyList`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: CURRENCY_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}

export const GetChargeBasisList = () => {
    return dispatch => {
        const url = `v1/Common/GetChargeBasisList`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: CHARGE_BASIS_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}

export const getUomList = () => {
    return dispatch => {
        const url = `v1/Common/GetPrimaryUomList`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: UOM_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}

export const getFileManagerList = () => {
    return dispatch => {
        const url = `v1/Common/GetFileManagerList`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: FILE_MANAGER_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
}


export const getMasterCompanyDetails = (para) => {
    return dispatch => {

        const url = `/MasterCompanyDetails/MasterCompanyDetails?MasterCompanyId=${para}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                localStorage.setItem("MasterCompanyDetails", JSON.stringify(result?.data));
                dispatch({
                    type: MASTER_COMPANY_DETAIL,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

export const getCustomerandVendorPaymentList = () => {
    return dispatch => {
        const url = `v1/Common/GetStandardTermsList`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: STANDARD_TERMS_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};



export const getAccounChargesList = (searchKeyword) => {
    return dispatch => {
        const url = `v1/Common/ChargesDescription_List?searchKeyword=${encodeURIComponent(searchKeyword)}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: CHARGES_DESCRIPTION_LIST,
                    payload: result?.data || [],
                });
                return result?.data; // <-- This is correct
            } else {
                return Promise.reject();
            }
        }, error => Promise.reject(error));
    };
};

export const GetAddressBookAccountVendorDetails = (searchKeyword) => {
    return dispatch => {
        const url = `v1/Common/GetAddressBookAccountVendorDetails?searchKeyword=${encodeURIComponent(searchKeyword)}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: CHARGES_DESCRIPTION_LIST,
                    payload: result?.data || [],
                });
                return result?.data; // <-- This is correct
            } else {
                return Promise.reject();
            }
        }, error => Promise.reject(error));
    };
};


export const GetAccountAdressbookModuleList = () => {
    return dispatch => {
        const url = `v1/Common/GetAccountAdressModuleList`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: ACCOUNT_ADDRESSBOOK_MODULE_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

export const GetAccountAdressbookBasisList = () => {
    return dispatch => {
        const url = `v1/Common/GetAccountAdressBasisList`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: ACCOUNT_ADDRESSBOOK_BASIS_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

export const SendEmail = async (payload) => {
    try {
        const url = `v1/SendEmail/SendEmail`;
        return APICall('post', payload, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    } catch (error) {
        return Promise.reject(error);
    }
}


export const GetCarrierList = () => {
    return dispatch => {
        const url = `v1/Common/GetCarrierList`
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: CARRIER_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

export const GetUnLocationByISOCodeList = (CountryCode) => {

    const url = `V1/Common/GetUnLocationByISOCodeList?CountryCode=${CountryCode}`;
    return APICall('get', {}, url).then(result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {

            return result?.data;
        } else {
            return Promise.reject();
        }
    }, error => {
        return Promise.reject(error);
    });


};
export const GetCountryStateList = (CountryCode) => {

    const url = `v1/Common/GetCountryStateList?CountryCode=${CountryCode}`;
    return APICall('get', {}, url).then(result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {

            return result?.data;
        } else {
            return Promise.reject();
        }
    }, error => {
        return Promise.reject(error);
    });


};
export const GetAccountAddressList = (id = 0) => {

    const url = `/v1/Common/GetAccountAddressList?AddressId=${id}`;
    return APICall('get', {}, url).then(result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {

            return result?.data;
        } else {
            return Promise.reject();
        }
    }, error => {
        return Promise.reject(error);
    });
};


export const GetOfficeTypeList = (CompanyId) => {
    return dispatch => {
        const url = `/v1/Common/GetOfficeTypeList?CompanyId=${CompanyId}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: OFFICE_TYPE,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

export const GetNotesTypeList = (CompanyId) => {
    return dispatch => {
        const url = `/v1/Common/GetNotesType?CompanyId=${CompanyId}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: NOTES_TYPE,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


// pendingapi
export const GetProfitCenterList = (CompanyId) => {
    return dispatch => {
        const url = `/v1/Common/GetProfitCenterList?CompanyId=${CompanyId}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: PROFIT_CENTER,
                    payload: result?.data || [],
                });
            }
        }, error => Promise.reject(error));
    };
};

export const GetPackageTypeList = () => {
    return dispatch => {
        const url = `/v1/Common/GetMasterPackageList`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: PACKAGE_TYPE,
                    payload: result?.data || [],
                });
            }
        }, error => Promise.reject(error));
    };
};

export const GetBlTypeList = (CompanyId = 0) => {
    return dispatch => {
        const url = `/v1/Common/GetBLTypesList?CompanyId=${CompanyId}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: BL_TYPE_LIST,
                    payload: result?.data || [],
                });

                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

// Ocean Export
// OES = Ocean Export Shipment
// OER = Ocean Export Rates


// Ocean Import
// OIS = Ocean Import Shipment
// OIR = Ocean Import Rates


// Air Export
// AES = Air Export Shipment
// AER = Air Export Rates


// Air Import
// AIS = Air Import Shipment
// AIR = Air Import Rates
export const GetDocumentTypeList = (ModuleType = 0) => {
    const url = `/v1/Common/GetDocumentTypeList?ModuleType=${ModuleType}`;
    return APICall('get', {}, url).then(result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {

            return result?.data || [];
        } else {
            return Promise.reject();
        }
    }, error => {
        return Promise.reject(error);
    });

};


///api/v1/Common/GetPrintDoc
///payload = OIS, OIR, AES, AER, AIS, AIR
export const GetPrintDoc = (payload) => {
    const url = `/v1/Common/GetPrintDoc?ForModule=${payload}`;
    return APICall('GET', {}, url).then(result => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
            return result?.data;
        } else {
            return Promise.reject();
        }
    }, error => {
        return Promise.reject(error);
    });
};

////api/v1/Common/GetColoaderList 
// param  Company_Id,Searchtxt = ""
export const GetColoaderList = (Company_Id, Searchtxt = "") => {
    return dispatch => {
        const url = `/v1/Common/GetColoaderList?Company_Id=${Company_Id}&Searchtxt=${Searchtxt}`;
        return APICall('get', {}, url).then(result => {
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: CLOADER_LIST,
                    payload: result?.data || [],
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};